import { ActionTree, ActionContext } from 'vuex';

import { storageClient } from '@/http-client';
import { camelToSnake, snakeToCamel } from '@/utils';

import { RootStateI, PaginationI } from '../state';
import { FileI, FilesStateI } from './state';

export const actions: ActionTree<FilesStateI, RootStateI> = {
  async upload(
    context: ActionContext<FilesStateI, RootStateI>,
    payload: {
      formData: FormData,
    },
  ): Promise<string[]> {
    const completedFiles: FileI[] = [];

    // extract files ONCE
    const files = payload.formData.getAll('file') as File[];

    // eslint-disable-next-line no-param-reassign
    context.state.uploadFiles = [];
    const downloadUrls: string[] = [];

    // populate UI state
    files.forEach((file) => {
      context.state.uploadFiles.push({
        id: 0,
        name: file.name,
        size: file.size,
        contentType: file.type,
        userId: 0,
        r2Key: '',
        r2Url: '',
        uploadCompleted: false,
        error: '',
        created: 0,
        updated: 0,
        folderId: null,
      });
    });

    // request upload URLs
    const { data } = await storageClient.post(
      '/api/storage/generate-upload-url',
      camelToSnake(context.state.uploadFiles),
    );

    const dataArray: FileI[] = snakeToCamel(data);

    // upload all files in parallel
    await Promise.all(
      dataArray.map(async (item: FileI, index: number) => {
        const file = files[index];
        if (!file || !item.r2Url) return;

        const response = await fetch(item.r2Url, {
          method: 'PUT',
          body: file,
          headers: {
            'Content-Type': file.type || 'application/octet-stream',
          },
        });

        if (response.ok) {
          // eslint-disable-next-line no-param-reassign
          item.uploadCompleted = true;
          completedFiles.push(item);
        } else {
          // eslint-disable-next-line no-param-reassign
          item.error = `Upload failed (${response.status})`;
        }
      }),
    );

    if (completedFiles.length > 0) {
      const { data: confirmedData } = await storageClient.post(
        '/api/storage/confirm-uploads',
        camelToSnake(completedFiles),
      );

      const confirmed: FileI[] = snakeToCamel(confirmedData);
      console.log('confirmed', confirmed);

      const urls = await Promise.all(
        confirmed.map(async (file) => {
          const res = await storageClient.get(
            `/api/storage/get-download-url/${file.id}`,
          );
          return res.data.url;
        }),
      );
      downloadUrls.push(...urls);
    }

    return downloadUrls;
  },

};
